export default __webpack_public_path__ + "static/media/SJA1440.34I-42058_-25208_0.8e2ada75.jpg";